import { UiRenderer } from "@agent/UiRenderer";
import type { UiPayload } from "@agent/uiSchema";
import { severityVariant } from "@subjects/cardSeverity";
import type { View } from "@views/viewsClient";

/**
 * Renders a SavedView's a2ui tree with the shared `UiRenderer` in display-only mode. A
 * view has no `render_id`, so the renderer's local model store is keyed on its uuid and
 * each view keeps its own (cosmetic) input state. Buttons are inert, so `onAction` never
 * fires.
 *
 * The card surface takes its severity tint (BE-1918): a `watch`/`urgent` surfaced view
 * gets the same `*-subtle` tint task cards use, so status reads off the card itself, not
 * just the accent bar.
 */
export const ViewRenderer = ({
  view,
  frameless = false,
}: {
  view: View;
  /** Render the view's body without its own card frame — for embedding inside
      another card (an estimate renders its notes above its line items). */
  frameless?: boolean;
}) => {
  const payload: UiPayload = {
    render_id: view.id,
    root: view.root,
    data: view.data,
  };

  return (
    <UiRenderer
      payload={payload}
      storeKey={view.id}
      onAction={() => {}}
      readOnly
      cardVariant={severityVariant(view.severity)}
      frameless={frameless}
    />
  );
};
